/* eslint-disable import/no-anonymous-default-export */
/* eslint-disable no-undef */
export default (approvedInvestment = [], action) => {
  switch (action.type) {
    case "GET_APPROVED":
      return action.payload;
    default:
      return approvedInvestment;
  }
};
